export function FormatCodingQuestion(text) {
    const lines = text.split('\n');
    let html = '';
    let inList = false;
  
    lines.forEach((line) => {
      const trimmed = line.trim();
  
      if (trimmed === '') {
        if (inList) {
          html += '</ul>';
          inList = false;
        }
        return;
      }
  
      if (/^(Input|Output|Constraints|Examples?):$/i.test(trimmed)) {
        if (inList) {
          html += '</ul>';
          inList = false;
        }
        html += `<h6>${trimmed}</h6>`;
      } else if (trimmed.startsWith('- ')) {
        if (!inList) {
          html += '<ul>';
          inList = true;
        }
        html += `<li>${trimmed.replace(/^[-•–]\s*/, '')}</li>`;
      } else if (trimmed.startsWith('Example')) {
        if (inList) {
          html += '</ul>';
          inList = false;
        }
        html += `<div class="ex-block"><h6>${trimmed}</h6>`;
      } else if (trimmed.startsWith('Input:') || trimmed.startsWith('Output:')) {
        html += `<pre><strong>${trimmed}</strong>\n`;
      } else {
        html += `<p>${trimmed}</p>`;
      }
    });
  
    if (inList) {
      html += '</ul>';
    }
  
    return html;
  }

export const formatMarkdownResponse = (rawText) => {
  if (!rawText || typeof rawText !== "string") return "";

  const abbreviationPattern = /\b(Mr|Mrs|Ms|Dr|Prof|Sr|Jr)\./g;

  let formatted = rawText
    // 1. Escape real newlines
    .replace(/\\n/g, '\n')

    // 2. Temporarily protect abbreviations
    .replace(abbreviationPattern, '__$1__')

    // 3. Sentence splitting: ONLY break after full stop + space + capital letter
    // BUT NOT if the capital is followed by a number (e.g., "1995") or within a markdown list
    .replace(/(\.)(\s+)(?=[A-Z][a-z])/g, '.\n') // break before capital letter, if it's not number

    // 4. Restore protected abbreviations
    .replace(/__(Mr|Mrs|Ms|Dr|Prof|Sr|Jr)__/g, '$1.')

    // 5. Bullet & numbered lists should be on new lines
    .replace(/(?<!\n)(\*|\-|\d+\.)\s+/g, '\n$&')

    // 6. Convert things like "Title:" into headers
    .replace(/^(.+?):$/gm, '#### $1')

    // 7. Remove stray \t or \r
    .replace(/[\t\r]/g, '')

    // 8. Clean up multiple newlines and trim
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .join('\n\n');

  return formatted;
};

 export const formatDateForChatComponent = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedDate = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                         "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedMonth = monthNames[date.getMonth()];

    return `${formattedHours}:${minutes} ${period}, ${formattedDate}-${formattedMonth}`;
  };

export default function chunkHistoryIntoPairs(history = []) {
  if (!Array.isArray(history)) return [];

  const result = [];

  for (let i = 0; i < history.length; i += 2) {
    const pair = history.slice(i, i + 2);
    if (pair.length === 2) result.push(pair);
  }

  return result;
}

export const isValidImageType = (file) => {
  const imageTypes = [
    "image/jpeg",  
    "image/png",    
    "image/gif",      
    "image/webp",      
    "image/svg+xml",  
    "image/bmp",      
    "image/tiff",     
    "image/x-icon",  
    "image/heic",      
    "image/avif",      
  ];

  return file && imageTypes.includes(file.type);
};

//To get the material id (filter store resource data with current selected subject and chapter)
   export const  getMaterialId=(uploadedResourceStore, selectedSubject, selectedChapter) =>{
    const match = uploadedResourceStore.find(
      (item) =>
        item.subject.toLowerCase() === selectedSubject.toLowerCase() &&
        item.chapter.toLowerCase() === selectedChapter.toLowerCase()
    );

    return match ? match.material_id : null;
  }

//formatting date ----> 15 may 2025
export const formatDate = (dateString) => {
  const d = new Date(dateString);

  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("en-US", { month: "short" });
  const year = d.getFullYear();

  return `${day} ${month} ${year}`;
};

//formatting date and time ----> 02:20 AM, 03-Nov
export const formatDateandTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const time = date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const day = date.toLocaleString("en-US", { day: "2-digit" });
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.toLocaleString("en-US", { year: "numeric" });

  return `${time}, ${day}-${month}-${year}`;
};

//truncate text upto 12 characters
export const truncateText = (text, maxLength = 12) => {
  if (!text) return "";
  return text.length > maxLength
    ? `${text.slice(0, maxLength)}...`
    : text;
};

export function formatDateTime(iso) {
  if (!iso) return { date: "—", time: "—", raw: null };
  const d = new Date(iso);
  if (isNaN(d)) return { date: "—", time: "—", raw: null };
  return {
    date: d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    time: d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    }),
    raw: d, // keep the actual Date object for range filtering
  };
}

